module.exports = __webpack_public_path__ + "static/media/deposit-ewallet-rocket.26799b0a.svg";